import { SVGProps, Ref, forwardRef } from 'react';

export const ChevronArrowDiagonalUpRightFilledSize16Glyph = forwardRef(
    (props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
        <svg
            width={16}
            height={16}
            viewBox="0 0 16 16"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            ref={ref}
            {...props}
        >
            <g>
                <path
                    d="M6.12 4.97a14 14 0 0 1-1.612-1.256L5.64 2.58c.493.433.936.78 1.35 1.048.797.518 1.42.7 2.006.664.6-.037 1.286-.31 2.19-.956A18 18 0 0 0 12.807 2L14 3.195a18 18 0 0 0-1.336 1.617c-.646.905-.92 1.59-.956 2.191-.036.585.146 1.209.664 2.007.268.413.615.856 1.048 1.349l-1.134 1.133a14 14 0 0 1-1.256-1.611c-.608-.937-.955-1.862-.925-2.855L3.131 14 2 12.87l6.974-6.974c-.993.03-1.918-.317-2.854-.925"
                    fill="currentColor"
                />
            </g>
        </svg>
    )
);
ChevronArrowDiagonalUpRightFilledSize16Glyph.displayName = 'ChevronArrowDiagonalUpRightFilledSize16Glyph';
